import { IWorkflow } from 'stores/Workflows/Types'
import { createContext, PropsWithChildren, useContext } from 'react'
import { Workflow } from 'stores/Workflows/Workflow'
import { AssigneeType, Property, SelectPropertyValue } from 'api/clients/PropertyClient'
import { WorkflowStatusProvider } from 'components/WorkflowStatus/WorkflowStatusProvider'
import { useArticle } from 'hooks/queries/articles/useArticle'

interface WorkflowProviderProps {
  workflow?: IWorkflow
  articleId: string
}

interface WorkflowProviderValue {
  workflow?: Workflow
  property?: Property<SelectPropertyValue>
  enabled: boolean
  folder?: IWorkflow['folder']
}

const WorkflowContext = createContext<WorkflowProviderValue>({
  enabled: false,
})

export const WorkflowProvider = ({
  workflow: workflowJson,
  articleId,
  children,
}: PropsWithChildren<WorkflowProviderProps>) => {
  const workflow = workflowJson ? Workflow.fromJSON(workflowJson) : undefined
  const property = workflowJson?.property
  const folder = workflowJson?.folder
  const assignee = { id: articleId, type: AssigneeType.Article }
  const { data } = useArticle(articleId)
  const permissions = data?.article?.almanac_file.permissions

  return (
    <WorkflowContext.Provider value={{ workflow, property, folder, enabled: true }}>
      <WorkflowStatusProvider
        workflow={workflow}
        assignee={assignee}
        property={property}
        folder={folder}
        permissions={permissions}
      >
        {children}
      </WorkflowStatusProvider>
    </WorkflowContext.Provider>
  )
}

export const useWorkflow = () => useContext(WorkflowContext)
